"use client";

import Typography from "@portal/components/atoms/v2/typography";
import { useEffect } from "react";
import { MainBox } from "../components/mainBox";
import { MapExperienceToIndex, MapIndexToExperience } from "./helpers/MapData";
import { GetIconForExperiencePage } from "./helpers/GetIconForExperiencePage";
import { RadioGroup } from "@headlessui/react";
import { IPageProps } from "@portal/types/robot/IPageProps";
import { RobotTextResources } from "@portal/assets/text/RobotTextResources";
import { useRobot } from "@portal/app/context/robotProvider";
import { IsBankNewNorwegian } from "@portal/helpers";
import { TextLine } from "@portal/components/atoms/v2/textLine";
import RadioComponentWithSelectionBox from "@portal/components/atoms/v2/radioComponentWithSelectionBox";
import { RobotFooterComponent } from "../components/footer";

export const ExperiencePage = ({ centerId, pageIndex, isDefaultLanguage }: IPageProps) => {
  const { riskLevelRequest: request, setIsDefaultLanguage, setExperience } = useRobot();
  const isButtonDisabled = request.experience === null;

  const texts = isDefaultLanguage ? RobotTextResources.primary : RobotTextResources.secondary;
  const options = [texts.PAGE_1_A, texts.PAGE_1_B, texts.PAGE_1_C];

  // Handling of centerId if the user has been redirected out of an iFrame and lost the centerId
  useEffect(() => {
    if (centerId && IsBankNewNorwegian(centerId)) {
      setIsDefaultLanguage(false);
    }
  }, [centerId, setIsDefaultLanguage]);

  const OnSelectionClick = (selectedOption: number) => {
    setExperience(MapIndexToExperience(selectedOption));
  };

  return (
    <>
      <MainBox>
        <Typography variant="H6">{texts.PAGE_1_SUBHEADER}</Typography>
        <TextLine />
        <div className="flex flex-col my-2.5">
          <RadioGroup value={MapExperienceToIndex(request.experience) ?? -1} onChange={OnSelectionClick} className="space-y-3">
            {options.map((text, i) => (
              <RadioComponentWithSelectionBox key={i} value={i} id={i.toString()} hideRadio smallPadding>
                {GetIconForExperiencePage(i)}
                <div className="flex flex-col p-2">
                  <Typography>{text}</Typography>
                </div>
              </RadioComponentWithSelectionBox>
            ))}
          </RadioGroup>
        </div>
      </MainBox>
      <RobotFooterComponent
        pageIndex={pageIndex}
        centerId={centerId}
        primaryButtonText={texts.BUTTON_NEXT}
        secondaryButtonText={texts.BUTTON_BACK}
        disabled={isButtonDisabled}
      />
    </>
  );
};
